/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from "react";
import TableTemplate from "./Table";
import CardLayout from "../Cards/CardLayout";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import CardError from "../feedBacks/CardError";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import { REFETCH_CONFIGURATION, ROWS_PER_PAGE } from "../../utils/constants";
import NoDeviceCardError from "../feedBacks/NoDeviceCardError";
import { useUtils } from "../../customHooks/useUtils";


const SitePerformanceTable = ({ company_id }: { company_id?: string }) => {
  const { FEEDBACK_MESSAGES, t } = useUtils();
  const [page, setPage] = React.useState(1);
  const [isNextPageLoading, setIsNextPageLoading] = React.useState(false);
  const columns = [
    t("table.device_name"),
    t("chart.transformer_load_rate"),
    t("readings.power_factor"),
    t("readings.voltage_unbalance_factor"),
    t("readings.current_unbalance_factor"),
    t("site_details.asset_capacity"),
  ];
  // const ROWS_PER_PAGE = 10;
  const handlePageChange = (newPage: number) => {
    setIsNextPageLoading(true);
    setPage(newPage);
  };

  const {
    data,
    isLoading: isDataLoading,
    error,
    refetch,
  }: any = useFetchData(
    ["/operations", "fetchSitePerformance", company_id],
    "/operations/performance",
    {
      page,
      page_size: ROWS_PER_PAGE,
      company_id,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  const isLoading = isDataLoading || isNextPageLoading;
  const tableData =
    (data as any)?.results.map((item: any) => ({
      [t("table.device_name")]: item.device_name,
      [t("site_details.asset_capacity")]: item.device_capacity,
      // [t("table.asset_type")]: item.device_type,
      [t("readings.current_unbalance_factor")]: item.current_unbalance,
      [t("readings.voltage_unbalance_factor")]: item.voltage_unbalance,
      [t("readings.power_factor")]: item.power_factor,
      [t("chart.transformer_load_rate")]: item.load_ratio,
      ...item,
    })) ?? [];

  useEffect(() => {
    refetch().finally(() => {
      setIsNextPageLoading(false);
    });
  }, [page, refetch]);
  return (
    <CardLayout
      title={t("table.site_performance")}
      className=" lg:!max-w-[50%] flex-1 lg:!justify-items-start lg:!items-start"
    >
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        (error as any).response.data.detail ? (
          <NoDeviceCardError
            message={FEEDBACK_MESSAGES.NO_DEVICE}
            className="!max-h-[150px]"
          />
        ) : (
          <CardError message="Error fetching data" />
        )
      ) : !tableData || tableData.length === 0 ? (
        <NoContent message={t("feedback_msg.no_devices")} />
      ) : (
        <TableTemplate
          className=""
          data={tableData}
          columns={columns}
          totalCount={data?.total_results || 0}
          styleCell={(value, column) => {
            // if (column === t("site_details.asset_capacity")) {
            //   if (Number(value) <= 2) return { color: "green" };
            //   if (Number(value) > 2 && Number(value) <= 4)
            //     return { color: "lightgreen" };
            //   if (Number(value) > 4 && Number(value) <= 5)
            //     return { color: "orange" };
            //   if (Number(value) > 5) return { color: "red" };
            // }
            if (column === t("readings.current_unbalance_factor")) {
              if (Number(value) <= 5) return { color: "green" };
              if (Number(value) > 5 && Number(value) <= 15)
                return { color: "lightgreen" };
              if (Number(value) > 15 && Number(value) <= 20)
                return { color: "orange" };
              if (Number(value) > 20) return { color: "red" };
            }
            if (column === t("readings.power_factor")) {
              if (Number(value) <= 0.8) return { color: "red" };
              if (Number(value) > 0.8 && Number(value) < 0.89)
                return { color: "orange" };
              if (Number(value) >= 0.9) return { color: "green" };
            }
            if (column === t("chart.transformer_load_rate")) {
              if (Number(value) <= 49) return { color: "orange" };
              if (Number(value) >= 50 && Number(value) <= 100)
                return { color: "green" };
              if (Number(value) > 100) return { color: "red" };
            }

            return { color: "black" };
          }}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={ROWS_PER_PAGE}
        />
      )}
    </CardLayout>
  );
};

export default SitePerformanceTable;
